import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AuthService } from '../authentication/auth.service';

import { SharedSettings } from '../models/shared-settings';

import { ThemeComponent } from './theme.component';
import {UsersService} from "@shared/services/users.service";
import {Router} from "@angular/router";
import { Subscription } from 'rxjs';

@Component({
  selector: 'theme-topbar',
  templateUrl: './theme.topbar.component.html'
})
export class ThemeTopBarComponent implements OnInit, OnDestroy {
    @Input() isPropak: boolean = false;
    @Input() isTestEnvironment: boolean = false;

    username: string;
    displayName: string;
    canImpersonate: boolean = false;
    showImpersonateDialog: boolean = false;
    impersonationUsername: string;

    subscriptions: Subscription[] = [];

    constructor(private app: ThemeComponent,
                private authService: AuthService,
                private userService: UsersService,
                private settings: SharedSettings,
                private router: Router) {

    }

    ngOnInit(): void {
        this.subscriptions = [
            this.authService.getAccount().subscribe(user => {
                this.username = user.username;
                this.displayName = user.name;
            }),

            this.authService.isUserInAnyRoles([ 'it', 'developers' ]).subscribe(isInRole => {
                this.canImpersonate = isInRole && !this.settings.isProduction;
            })
        ];
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

    menuButtonClick(event: any): void {
        this.app.onMenuButtonClick(event);
    }

    logout(): void {
        this.authService.logout();
    }

    openDialog() {
        this.showImpersonateDialog = true;

    }

    setImpersonation() {
        this.userService.ImpersonateUser(this.impersonationUsername).subscribe(u => {
            this.displayName = u.displayName;
            this.showImpersonateDialog = false;
            this.router.navigate(['/']).then(() => window.location.reload());
        }, () => this.showImpersonateDialog = false);
    }

    cancelImpersonation() {
        this.userService.CancelImpersonateUser().subscribe(_ => {
            this.showImpersonateDialog = false
            this.router.navigate(['/']).then(() => window.location.reload());
        })
    }
}
